import * as PIXI from "pixi.js";
import data from "./configs/data";
import {Dice} from "./Dice";

export class PredictionPickerTextField extends PIXI.Container {

    private readonly HEADER_TEXT_POSITION: any = new PIXI.Point(0, -49);

    private readonly DEFAULT_ANCHOR_POINT: any = new PIXI.Point(0.5, 0.5);

    private readonly HEADER_TEXT_STYLE = {
        fontSize: 23,
        fontFamily: "RobotoRegular",
        fontWeight: "bolder",
        fill: "#b2b2b2",
    };
    private readonly VALUE_TEXT_STYLE = {
        fontSize: 30,
        fontFamily: "RobotoRegular",
        fill: "#ffffff",
    };

    private valueText: PIXI.Text;
    private headerText: PIXI.Text;

    constructor(headerText: string) {
        super();
        this.createAndAddBackground();
        this.createHeaderText(headerText);
        this.createAndAddValueText();
    }

    public setHeader(value: string): void {
        this.headerText.text = value;
    }

    public setValue(value: string): void {
        this.valueText.text = value;
    }

    private createAndAddValueText(): void {
        this.valueText = new PIXI.Text("", this.VALUE_TEXT_STYLE);
        this.valueText.position.y = -6;
        this.valueText.anchor = this.DEFAULT_ANCHOR_POINT;
        this.addChild(this.valueText);
    }

    private createHeaderText(text: string): void {
        this.headerText = new PIXI.Text(text, this.HEADER_TEXT_STYLE);
        this.headerText.position = this.HEADER_TEXT_POSITION;
        this.headerText.anchor = this.DEFAULT_ANCHOR_POINT;
        this.addChild(this.headerText);
    }

    private createAndAddBackground(): void {
        const background = PIXI.Sprite.fromImage(data.images.payoutBackground);
        background.anchor = this.DEFAULT_ANCHOR_POINT;
        background.scale = Dice.ELEMENTS_SCALE;
        this.addChild(background);
    }
}



// WEBPACK FOOTER //
// ./src/app/PredictionPickerTextField.ts